import React, { useEffect, useState } from "react";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../../components/common/CustomTable";
import { useNavigate } from "react-router-dom";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { useDispatch, useSelector } from "react-redux";
import {
   fetchAdhocLaneListAsync,
   updateAdhocLaneReviewStautsAsync,
} from "../../../../redux/features/adhocLaneSlice";
import { getFleetMasterDropdownDataAsync } from "../../../../redux/features/fleetMaster";
import RouteNames from "../../../../AppRoutes/RouteName";
import { ROLES } from "../../../../constansts/Roles";
import toast from "react-hot-toast";

const AdhocLaneView = () => {
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const [isChecked, setIsChecked] = useState({}); // State to manage toggle
   const [roleName, setRoleName] = useState({});
   const [isUpdated, setIsUpdated] = useState(false);

   const laneListData = useSelector((state) => state.adhocLane.laneList);
   const locationData = useSelector((state) => state.fleetMaster.location);
   const reduxState = useSelector((state) => state);

   console.log({ reduxState });

   const userRoleId = useSelector((state) => state?.auth?.user?.data?.user?.role_id);

   useEffect(() => {
      for (const key in ROLES) {
         if (ROLES[key] === userRoleId) {
            // roleName = key;
            setRoleName(key);
         }
      }
   }, [userRoleId]);

   useEffect(() => {
      if (locationData?.length === 0 || !locationData) {
         dispatch(getFleetMasterDropdownDataAsync());
      }
   }, [locationData]);

   useEffect(() => {
      fetchLanesData();
   }, []);

   useEffect(() => {
      if (isUpdated) {
         dispatch(fetchAdhocLaneListAsync({}));
         setIsUpdated(false);
      }
   }, [isUpdated]);

   const fetchLanesData = () => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         fetchAdhocLaneListAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
         })
      );
   };

   // Update review status
   const handleReviewStatus = (laneId, status) => {
      const request = {
         id: laneId,
         stat: status,
         model_id: "2",
         action_id: "3",
         _method: "PATCH",
      };
      dispatch(backdropLoadingAction(true));
      dispatch(
         updateAdhocLaneReviewStautsAsync({
            data: request,
            done: () => {
               dispatch(backdropLoadingAction(false));
               setIsUpdated(true);
               toast.success("Updated successfully");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               toast.error(error);
            },
         })
      );
   };

   const toggleSwitch = () => {
      setIsChecked(isChecked ? (isChecked = true) : (isChecked = false)); // Toggle the state
   };
   const columns = [
      {
         name: "Customer Name",
         width: "160px",
         selector: (row) => row?.customername,
         sortable: true,
      },
      {
         name: "Origin",
         width: "160px",
         selector: (row) => {
            const origin = locationData?.filter(
               (item) => item?.id === parseInt(row?.origin?.toString())
            );

            return origin[0]?.name;
         },
         sortable: true,
      },
      {
         name: "Destination",
         width: "160px",
         selector: (row) => {
            const destination = locationData?.filter(
               (item) => item?.id === parseInt(row?.destination?.toString())
            );

            return destination[0]?.name;
         },
         sortable: true,
      },
      {
         name: "Lane Name",
         width: "240px",
         selector: (row) => row?.lane_name,
      },
      {
         name: "Vehicle Type",
         width: "120px",
         selector: (row) => row?.vehicle_type,
      },
      {
         name: "Request Id",
         width: "120px",
         selector: (row) => row?.requestid,
      },
      {
         name: "Review Status",
         width: "150px",
         selector: (row) => {
            const status = row?.review_status;
            const btnColor =
               status === "pending"
                  ? "warning"
                  : status === "rejected"
                  ? "danger"
                  : status === "approved"
                  ? "success"
                  : "";
            return (
               <span className={`text-${btnColor} mx-2 text-uppercase font-weight-bold`}>
                  {row.review_status}
               </span>
            );
         },
      },
      {
         name: "Action",
         selector: (row) => {
            const status = row.review_status;
            return (
               <>
                  <button
                     className="btn btn-primary mx-2"
                     onClick={() => {
                        navigate("/adhoc-lane/edit/" + row.id);
                     }}
                  >
                     {roleName === "management" ? "View" : "Edit"}
                  </button>

                  {roleName === "management" && (
                     <>
                        {(status === "pending" ||
                           status === "rejected" ||
                           status === null) && (
                           <button
                              className="btn btn-success mx-2"
                              onClick={() => handleReviewStatus(row.id, "approved")}
                           >
                              APPROVE
                           </button>
                        )}
                        {(status === "pending" || status === null) && (
                           <button
                              className="btn btn-danger mx-2"
                              onClick={() => handleReviewStatus(row.id, "rejected")}
                           >
                              REJECT
                           </button>
                        )}
                     </>
                  )}
               </>
            );
         },
      },
   ];

   return (
      <div>
         <BodyHeader title="View AdHoc Lane & Customer " />
         <div className=" d-flex justify-content-end">
            <CustomInput
               inputType="text"
               placeholder="Search..."
               id="search"
               onChange={(e) => {}}
            />
         </div>
         <CustomTable columns={columns} data={laneListData} />
      </div>
   );
};

export default AdhocLaneView;
